import { configureStore } from "@reduxjs/toolkit";

// masters
import common from "./common";
import masters from "./masters";
import aboutus from "./Aboutus";
import services from "./services";
import contain from "./contain";

// ✅ ADD THIS
import settingsReducer from "../features/settings/Slice";

export const store = configureStore({
  reducer: {
    contain,
    common,
    masters,
    aboutus,
    services,

    // ✅ THIS IS REQUIRED
    settings: settingsReducer,
  },
});